module.exports = __webpack_public_path__ + "static/media/offres_auto_2.ca36c13f.png";